var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "5s2nquwzsa",
    width: "139.3%",
    height: "139.3%",
    x: "-19.6%",
    y: "-12.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0657835145 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "udw67weihb",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    rx: 14
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#5s2nquwzsa)",
    xlinkHref: "#udw67weihb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#udw67weihb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4545",
    fillRule: "nonzero",
    d: "M15.1 14l4.672-4.673c.304-.304.304-.795 0-1.099-.304-.304-.795-.304-1.1 0L14 12.901 9.327 8.228c-.304-.304-.795-.304-1.099 0-.304.304-.304.795 0 1.1L12.901 14l-4.673 4.673c-.304.304-.304.795 0 1.099.152.152.35.228.55.228.199 0 .398-.076.55-.228L14 15.099l4.673 4.673c.151.152.35.228.55.228.198 0 .397-.076.549-.228.304-.304.304-.795 0-1.1L15.099 14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorClose);
export default __webpack_public_path__ + "static/media/error-close.9dcc08d37c1e6c9c65a3c637c4b1f3e9.svg";
export { ForwardRef as ReactComponent };